import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {PlanItemModel} from '@/libs/Api';
import {PlanItemsDataService} from '@/libs/plan-items/plan-items-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const planItemsStore = registerCrudStore<PlanItemModel, PlanItemModel>(BusinessModule.PlanItem, new PlanItemsDataService());
